import React from 'react';

import type {
  ComponentRenderProps,
  DividerProps,
} from '../../../types/dynamic_views';

export const DividerComponent: React.FC<ComponentRenderProps> = ({
  component,
  className = '',
}) => {
  const props = component.props as DividerProps;
  const {
    orientation = 'horizontal',
    variant = 'solid',
    spacing = 'md',
    color = 'neutral',
  } = props;

  // Build CSS classes
  const orientationClasses = {
    horizontal: 'w-full h-px',
    vertical: 'h-full w-px',
  };

  const variantClasses = {
    solid: 'border-solid',
    dashed: 'border-dashed',
    dotted: 'border-dotted',
  };

  const spacingClasses = {
    sm: orientation === 'horizontal' ? 'my-2' : 'mx-2',
    md: orientation === 'horizontal' ? 'my-4' : 'mx-4',
    lg: orientation === 'horizontal' ? 'my-6' : 'mx-6',
  };

  // Token-backed border colors so both variants flip with the theme. The two
  // entries were previously the same hardcoded hex, which made `muted`
  // indistinguishable from `neutral` despite the name.
  const colorClasses = {
    neutral: 'border-secondary',
    muted: 'border-tertiary',
  };

  // Determine border direction based on orientation
  const borderClass = orientation === 'vertical' ? 'border-l-1' : 'border-t-1';

  const allClasses = [
    orientationClasses[orientation] || orientationClasses.horizontal,
    variantClasses[variant] || variantClasses.solid,
    spacingClasses[spacing] || spacingClasses.md,
    colorClasses[color] || colorClasses.neutral,
    borderClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <hr
      className={allClasses}
      data-component-id={component.id}
      data-orientation={orientation}
    />
  );
};

export default DividerComponent;
